import type {Prompt} from '@cp/model';
import {useCallback, useState} from 'react';
import {promptsGetPdfExtractQuestion} from '../../api/callable/prompts';

export function useGetPdfExtractQuestionPrompt() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  const getPdfExtractQuestionPrompt = useCallback(async (additionalInfo?: string): Promise<Prompt> => {
    setLoading(true);
    setError(undefined);
    try {
      return await promptsGetPdfExtractQuestion({additionalInfo: additionalInfo || undefined});
    } catch (err) {
      const e = err instanceof Error ? err : new Error(String(err));
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    getPdfExtractQuestionPrompt,
    loading,
    error,
  };
}
